__turbopack_context__.v({
  "alignEnd": "drop-down-module__xT6-0G__alignEnd",
  "dropdown": "drop-down-module__xT6-0G__dropdown",
  "root": "drop-down-module__xT6-0G__root",
  "triggerWidth": "drop-down-module__xT6-0G__triggerWidth",
});
